import HTMLReactParser from 'html-react-parser';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './NavBar.css';
class NavBarShan extends Component {
  constructor(props) {
    super(props);
    this.ClickNavButton = this.ClickNavButton.bind(this);
    this.state = {
      NavBarTitles: [
        { title: 'HomePage', page: 'HomePage', index: 0, icon: '<i class="fas fa-home"></i>' },
        { title: 'About', page: 'About', index: 1, icon: '<i class="fas fa-address-card"></i>' },
        { title: 'Skills', page: 'Skill', index: 2, icon: '<i class="fab fa-superpowers"></i>' },
        { title: 'My Work', page: 'MyWork', index: 3, icon: '<i class="fas fa-briefcase"></i>' },
        { title: 'Contact', page: 'Contact', index: 4, icon: '<i class="fas fa-id-badge"></i>' },
        { title: 'Login', page: 'Login', index: 5, icon: '<i class="fas fa-sign-in-alt"></i>' }
      ]
    }
  }

  componentDidMount() {

  }

  ClickNavButton = (e) => {
    this.props.LoggedInPage('LoggedInPage', {
      SelectedPage: e.index
    })
    this.props.history.push(`/Shan/${e.page}`);
  }


  render() {
    return (<>
      <div className='NavBarLoginOuterDiv'>
        <div className='NavBarDivLoggedIn'>
          <div className={this.props.localStorageData?.LoggedInPage?.SelectedPage === 0 ? 'titleLoginNavBarSel titleLoginNavBarCom' : 'titleLoginNavBar titleLoginNavBarCom'} onClick={(e) => this.ClickNavButton(this.state.NavBarTitles[0])}>
            <div>
              {HTMLReactParser(this.state.NavBarTitles[0]?.icon)}
            </div>
            {this.state.NavBarTitles[0].title}
          </div>
          <div className={this.props.localStorageData?.LoggedInPage?.SelectedPage === 1 ? 'titleLoginNavBarSel titleLoginNavBarCom' : 'titleLoginNavBar titleLoginNavBarCom'} onClick={(e) => this.ClickNavButton(this.state.NavBarTitles[1])}>
            <div>
              {HTMLReactParser(this.state.NavBarTitles[1]?.icon)}
            </div>
            {this.state.NavBarTitles[1].title}
          </div>
          <div className={this.props.localStorageData?.LoggedInPage?.SelectedPage === 2 ? 'titleLoginNavBarSel titleLoginNavBarCom' : 'titleLoginNavBar titleLoginNavBarCom'} onClick={(e) => this.ClickNavButton(this.state.NavBarTitles[2])}>
            <div>
              {HTMLReactParser(this.state.NavBarTitles[2]?.icon)}
            </div>
            {this.state.NavBarTitles[2].title}
          </div>
          <div className={this.props.localStorageData?.LoggedInPage?.SelectedPage === 3 ? 'titleLoginNavBarSel titleLoginNavBarCom' : 'titleLoginNavBar titleLoginNavBarCom'} onClick={(e) => this.ClickNavButton(this.state.NavBarTitles[3])}>
            <div>
              {HTMLReactParser(this.state.NavBarTitles[3]?.icon)}
            </div>
            {this.state.NavBarTitles[3].title}
          </div>
          <div className={this.props.localStorageData?.LoggedInPage?.SelectedPage === 4 ? 'titleLoginNavBarSel titleLoginNavBarCom' : 'titleLoginNavBar titleLoginNavBarCom'} onClick={(e) => this.ClickNavButton(this.state.NavBarTitles[4])}>
            <div>
              {HTMLReactParser(this.state.NavBarTitles[4]?.icon)}
            </div>
            {this.state.NavBarTitles[4].title}
          </div>
          <div className={this.props.localStorageData?.LoggedInPage?.SelectedPage === 5 ? 'titleLoginNavBarSel titleLoginNavBarCom' : 'titleLoginNavBar titleLoginNavBarCom'} onClick={(e) => this.ClickNavButton(this.state.NavBarTitles[5])}>
            <div>
              {HTMLReactParser(this.state.NavBarTitles[5]?.icon)}
            </div>
            {this.state.NavBarTitles[5].title}
          </div>
        </div>
      </div>
    </>);
  }
}

const mapStateToProps = (state) => ({
  localStorageData: state.Reducer
})

const mapDispatchToProps = (dispatch) => ({
  LoggedInPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  })
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavBarShan));